__turbopack_context__.v({
  "brand-banner": "BrandBanner-module-scss-module__KGdbda__brand-banner",
  "brand-banner__image": "BrandBanner-module-scss-module__KGdbda__brand-banner__image",
  "floating": "BrandBanner-module-scss-module__KGdbda__floating",
  "rotate": "BrandBanner-module-scss-module__KGdbda__rotate",
});
